import services from '~/services';
import coreServices from '~/services/_core';

export default (context, inject) => {
  try {
    const result = {
      _core: {}
    };

    coreServices.map(Service => {
      result._core[Service.SERVICE_NAME] = () => new Service(context);
    });

    services.map(Service => {
      result[Service.SERVICE_NAME] = () => new Service(context);
    });

    inject('services', result);
  } catch (err) {
    console.error('Error/Services/Plugin', err);
  }
};

